import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UtilisationDashboardLayer from "../components/dashboards/UtilisationDashboardLayer";

const UtilisationDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Utilisation Dashboard">
        <UtilisationDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default UtilisationDashboardPage;
